



















import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { IModel3d } from '@/shared/model/model-3-d.model';
import Model3dService from '@/entities/model-3-d/model-3-d.service';

const Potree = window.Potree;
console.log(Potree);

@Component
export default class Model3DViewer extends Vue {
  get model3dId() {
    return parseInt(this.$route.params.model3dId);
  }

  @Prop() mobileMode: boolean;
  accessToken: string = '';
  model3d: IModel3d;

  style = {};

  formatDate(date) {
    if (!date) return date;
    let s = date + '';
    date = s.substring(0, s.indexOf('T'));
    date = date.split('-');
    date = date[2] + '/' + date[1] + '/' + date[0];
    return date;
  }

  async mounted() {
    let model3dService = new Model3dService();
    if (this.mobileMode) {
      this.accessToken = this.$route.query.accessToken as string;
      this.model3d = await model3dService.findByAccessToken(this.model3dId, this.accessToken);
      this.style = {
        position: 'fixed',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        'z-index': 9999,
      };
    } else {
      this.model3d = await model3dService.find(this.model3dId);
    }

    const viewer = new Potree.Viewer(this.$refs.potree_render_area);

    viewer.setEDLEnabled(true);
    viewer.setFOV(60);
    viewer.setPointBudget(1000 * 1000);
    viewer.setClipTask(Potree.ClipTask.SHOW_INSIDE);
    viewer.loadSettingsFromURL();

    viewer.setControls(viewer.orbitControls);

    // let url = 'http://localhost:8080/api/get-3d-model/metadata.json'
    // let url = './pointcloud/output/metadata.json'
    let url;
    url = `/api/model3d-data/get-file?filePath=${this.model3d.potreeFolderPath}/metadata.json`;
    // let url = 'http://localhost:52123/output/metadata.json'
    Potree.loadPointCloud(url).then(
      e => {
        let pointCloud = e.pointcloud;
        let material = pointCloud.material;

        material.activeAttributeName = 'rgba';
        material.minSize = 2;
        material.pointSizeType = Potree.PointSizeType.FIXED;

        viewer.scene.addPointCloud(pointCloud);

        viewer.fitToScreen();
      },
      e => console.error('ERROR: ', e)
    );
  }
}
